/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_Username_IdInputs */

const en_users_detail_username_id = /** @type {(inputs: Users_Detail_Username_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username / ID`)
};

const pt_br2_users_detail_username_id = /** @type {(inputs: Users_Detail_Username_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário / ID`)
};

/**
* | output |
* | --- |
* | "Username / ID" |
*
* @param {Users_Detail_Username_IdInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_username_id = /** @type {((inputs?: Users_Detail_Username_IdInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Username_IdInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_username_id(inputs)
	return pt_br2_users_detail_username_id(inputs)
});